(() => {
  if (window.__BT_FreeShipBoundV4) return;
  window.__BT_FreeShipBoundV4 = true;

  const ROOT_ID = 'product-freeshipping-bar';
  const BAR_SELECTOR = '.free-offer-bar';
  const REFRESH_DELAY = 150;

  let lastCartSig = null;
  let refreshTimer = null;
  let refreshInFlight = false;
  let observer = null;

  function getRoot() {
    return document.getElementById(ROOT_ID);
  }

  function getBar(root = getRoot()) {
    return root?.querySelector(BAR_SELECTOR) || null;
  }

  function getBarTargetWidth(bar) {
    if (!bar) return null;
    const target = parseFloat(bar.dataset.currentWidth || '0');
    return Number.isNaN(target) ? null : target;
  }

  function prepareBarForAnimation(root, bar) {
    const target = getBarTargetWidth(bar);
    if (!root || !bar || target === null) return null;

    root.setAttribute('data-animated', '1');
    bar.style.transition = 'none';
    bar.style.width = '0%';

    void bar.offsetWidth;

    return target;
  }

  function animateBar(root = getRoot()) {
    const bar = getBar(root);
    const target = prepareBarForAnimation(root, bar);
    if (target === null) return;

    requestAnimationFrame(() => {
      bar.style.transition = 'width 700ms ease-in-out';
      bar.style.width = `${target}%`;
    });
  }

  function setBarImmediately(root = getRoot()) {
    const bar = getBar(root);
    const target = getBarTargetWidth(bar);
    if (!root || !bar || target === null) return;

    root.setAttribute('data-animated', '1');
    bar.style.transition = 'none';
    bar.style.width = `${target}%`;

    requestAnimationFrame(() => {
      bar.style.transition = 'width 700ms ease-in-out';
    });
  }

  function initBar(root = getRoot(), { animate = true } = {}) {
    if (!root) return;
    if (animate) {
      animateBar(root);
    } else {
      setBarImmediately(root);
    }
  }

  function getRequestUrl(input) {
    if (!input) return '';
    if (typeof input === 'string') return input;
    if (input.url) return input.url;
    return '';
  }

  async function getCartSignature() {
    const response = await fetch('/cart.js', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!response.ok) return null;

    const cart = await response.json();
    return `${cart.item_count}|${cart.total_price}`;
  }

  async function fetchFreshSectionHTML(sectionId) {
    const url = new URL(window.location.href);
    url.searchParams.set('sections', sectionId);

    const response = await fetch(url.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!response.ok) return null;

    const json = await response.json();
    return json?.[sectionId] || null;
  }

  async function refreshFromPageHTML() {
    const currentRoot = getRoot();
    if (!currentRoot) return;

    const sectionId = currentRoot.dataset.sectionId;
    if (!sectionId) return;

    const cartSig = await getCartSignature();
    if (cartSig && cartSig === lastCartSig) return;
    if (cartSig) lastCartSig = cartSig;

    const html = await fetchFreshSectionHTML(sectionId);
    if (!html) return;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const freshRoot = doc.getElementById(ROOT_ID);
    if (!freshRoot) return;

    currentRoot.replaceWith(freshRoot);
    initBar(freshRoot, { animate: true });
  }

  function scheduleRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);

    refreshTimer = setTimeout(async () => {
      if (refreshInFlight) return;

      refreshInFlight = true;
      try {
        await refreshFromPageHTML();
      } catch (error) {
        console.error('[BT Free Shipping Bar] Refresh failed:', error);
      } finally {
        refreshInFlight = false;
      }
    }, REFRESH_DELAY);
  }

  function watchForRootReplacement() {
    if (observer) observer.disconnect();

    observer = new MutationObserver(() => {
      const root = getRoot();
      if (!root) return;

      if (!root.dataset.btInitialized) {
        root.dataset.btInitialized = 'true';
        initBar(root, { animate: true });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    const root = getRoot();
    if (root && !root.dataset.btInitialized) {
      root.dataset.btInitialized = 'true';
      initBar(root, { animate: true });
    }
  }

  document.addEventListener('eurus:cart:items-changed', scheduleRefresh);

  const originalFetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    try {
      const url = getRequestUrl(args[0]);
      if (/\/cart\/(add|change|update|clear)\.js(\?|$)/.test(url) && response.ok) {
        scheduleRefresh();
      }
    } catch (error) {
      console.error('[BT Free Shipping Bar] Fetch hook failed:', error);
    }

    return response;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      watchForRootReplacement();
    });
  } else {
    watchForRootReplacement();
  }
})();